/* global document */
/* eslint-disable import/no-unresolved, import/extensions */

import 'core-js/stable';
import 'regenerator-runtime/runtime';

import { createRoot } from 'react-dom/client';

import EntryComponent from '../../src/index.js';

const container = document.getElementById('app');
const root = createRoot(container);
root.render(<EntryComponent />);
